<template>
  <div class="p-basic">
    <exact-search ref="exactSearch" :state="state" />
    <exact-list
      ref="exactList"
      :state="state"
      :table-h="tableH1"
      :handle-add="handleAdd"
      :handle-edit="handleEdit"
      :handle-delete="handleDelete"
      :export-org="exportOrg"
    />
    <entity-dialog
      :state="state"
      :module-name="moduleName"
      :visible="entityDlgVis"
      :action="entityDlgActn"
      :entity="state.entity"
      :update-vis="updateEntityDlgVis"
      :handle-save="handleSave"
      :selectValue1="selectValue1"
      :cascaderValue1="cascaderValue1"
    />
  </div>
</template>

<script>
import axios from "axios";
import PageList from "@/mixins/pageList";
import store from "./store";
import ExactSearch from "./components/exactSearch";
import ExactList from "./components/exactList";
import EntityDialog from "./components/entityDialog";

export default {
  name: "dataResource",
  mixins: [PageList],
  components: {
    ExactSearch,
    ExactList,
    EntityDialog,
  },
  data() {
    return {
      // store唯一标识
      storeKey: "dataResource",
      // 模块名称
      moduleName: `${this.$t('language.5o6wak4kg480')}`,
      selectValue1: "",
      cascaderValue1: "",
    };
  },
  created() {
    this.registStore(store);
    this.queryListDataType();
  },
  methods: {
    addChange() {
      this.selectValue1 = "";
      this.cascaderValue1 = [];
    },
    editChange(id) {
      axios({
        method: "post",
        url: `/data/get?tenementCode=${this.$store.state.app.tenementInfoObj.tenementCode}`,
        data: {
          data: {
            id: id,
          },
        },
      })
        .then((resolve) => {
          this.selectValue1 = resolve.data.data.orgName;
          this.cascaderValue1 = resolve.data.data.belongOrgId.reverse();
        })
        .catch((reject) => {
          console.log("getExtByTenementCodeData 请求失败", reject);
        });
    },
    queryListDataType(payload) {
      return this.dispatch("queryListDataType", payload);
    },
    changeType(payload) {
      return this.dispatch("changeType", payload);
    },
    queryOrgTreeList(payload) {
      return this.dispatch("queryOrgTreeList", payload);
    },
    queryOrgIdTreeList(payload, id) {
      return this.dispatch("queryOrgIdTreeList", payload, id);
    },
    exportOrg() {
      //获取查询参数
      let param = this.$refs.exactSearch.queryParam();

      const _origin = window.location.origin;
      let url = `${_origin}${process.env.VUE_APP_API_PREFIX}/data/exportDataResource`;
      console.log(param, _origin, url, "param");
      const tenementCode = this.$store.state.app.tenementInfoObj.tenementCode;
      axios
        .request({
          url,
          method: "post",
          responseType: "blob",
          params: { tenementCode },
          data: { data: param },
        })
        .then((resolve) => {
          const blob = resolve.data;
          const href = URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          const filename = resolve.headers["content-disposition"];
          const filenameString = "filename=";
          const index = filename.indexOf(filenameString);
          if ("download" in anchor) {
            if (index !== -1) {
              anchor.download = filename.slice(index + filenameString.length);
            }
            anchor.href = href;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
          }
        })
        .catch((reject) => {
          this.$message({
            message: `${this.$t('language.5o6wak4kgko0')}`,
            type: "error",
            center: true,
          });
          console.log("导出按钮请求失败", reject);
        });
    },
  },
};
</script>
